import { SVGProps } from 'react';
const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='https://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    className='mail_svg__feather mail_svg__feather-mail'
    aria-labelledby='mailTitle'
    {...props}
  >
    <title id='mailTitle'>Mail</title>
    <path d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' />
    <path d='m22 6-10 7L2 6' />
  </svg>
);
export default SvgMail;
